import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ breakpoints, spacing: { unit } }) => ({
  container: {
    [breakpoints.up("sm")]: {
      alignItems: "center",
      flexDirection: "row",
      flexWrap: "nowrap"
    },
    padding: `${unit * 4}px 0 ${unit * 5}px`
  },
  summary: {
    width: "300px"
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
